<template>
  <div class="step-form">
    <DxCheckBox
      :value="!!formData.generate_document"
      :text="$t('stock_management.storage_losses.generate_document')"
      @value-changed="$emit('input', { generate_document: !!$event.value })"
    />
  </div>
</template>

<script>
import { DxCheckBox } from "devextreme-vue/check-box";

export default {
  name: "StorageLossDocumentOptions",
  components: { DxCheckBox },
  props: {
    formData: { type: Object, default: () => ({}) },
  },
};
</script>
